// @flow
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import makeStyles from '@material-ui/core/styles/makeStyles';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Divider from '@material-ui/core/Divider';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import type { User as UserType } from '../../../../types';

const useStyles = makeStyles((theme) => ({
    deactivate: {
        color: theme.palette.error.dark
    }
}));

type Props = $ReadOnly<{
    user: UserType,

    onEdit: () => void
}>;

function UserMenu({ user, onEdit }: Props) {
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (e) => setAnchorEl(e.currentTarget);
    const handleClose = () => setAnchorEl(null);

    const handleAction = (action) => () => {
        handleClose();
        action();
    };

    return (
        <React.Fragment>
            <IconButton
                aria-label="more"
                aria-controls="long-menu"
                aria-haspopup="true"
                onClick={handleClick}
            >
                <MoreVertIcon />
            </IconButton>
            <Menu
                id="long-menu"
                anchorEl={anchorEl}
                keepMounted
                open={open}
                onClose={handleClose}
            >
                <MenuItem onClick={handleClose} disabled>
                    <FormattedMessage
                        id="options.user.menu.sendMessage"
                        defaultMessage="Send message"
                    />
                </MenuItem>
                <MenuItem onClick={handleClose} disabled>
                    <FormattedMessage
                        id="options.user.menu.sendEmail"
                        defaultMessage="Send email"
                    />
                </MenuItem>
                <MenuItem onClick={handleAction(onEdit)}>
                    <FormattedMessage
                        id="options.user.menu.edit"
                        defaultMessage="Edit"
                    />
                </MenuItem>
                <MenuItem onClick={handleClose} disabled>
                    <FormattedMessage
                        id="options.user.menu.resetPassword"
                        defaultMessage="Reset password"
                    />
                </MenuItem>

                <Divider />

                <MenuItem className={classes.deactivate} disabled onClick={handleClose}>
                    <FormattedMessage
                        id="options.user.menu.deactivate"
                        defaultMessage="Deactivate"
                    />
                </MenuItem>
            </Menu>
        </React.Fragment>
    );
}

export default UserMenu;